import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9 } from "styled-components";
import React from "react";
import { Icon } from "~/features/ui/icon";
import { Asset } from "~/features/craft/asset";
import CaretLeft from "~/public/icons/caret-left.svg";
import CaretRight from "~/public/icons/caret-right.svg";
type ControlItem = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  thumbnail?: any;
};
type Props = {
  items: ReadonlyArray<ControlItem>;
  activeIndex: number;
  onSelect: (index: number) => void;
};
export function CoreVideoFeaturesGalleryControls({
  items,
  activeIndex,
  onSelect
}: Props) {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    const activeEl = container.querySelector(`[data-control-idx="${activeIndex}"]`);
    if (!activeEl) return;
    const containerRect = container.getBoundingClientRect();
    const activeRect = activeEl.getBoundingClientRect();
    let newScrollLeft = container.scrollLeft;
    let shouldScroll = false;
    if (activeRect.left < containerRect.left) {
      newScrollLeft += activeRect.left - containerRect.left - 8;
      shouldScroll = true;
    } else if (activeRect.right > containerRect.right) {
      newScrollLeft += activeRect.right - containerRect.right + 8;
      shouldScroll = true;
    }
    if (shouldScroll) {
      container.scrollTo({
        left: newScrollLeft,
        behavior: "smooth"
      });
    }
  }, [activeIndex]);
  const goPrev = () => {
    if (activeIndex > 0) onSelect(activeIndex - 1);
  };
  const goNext = () => {
    if (activeIndex < items.length - 1) onSelect(activeIndex + 1);
  };
  const isPrevDisabled = activeIndex === 0;
  const isNextDisabled = activeIndex === items.length - 1;
  return <_StyledDiv $_css={[{
    "display": "flex",
    "alignItems": "center",
    "columnGap": "0.4rem"
  }]}>
      <_StyledButton type="button" onClick={goPrev} disabled={isPrevDisabled} aria-label="Previous" $_css2={[{
      "display": "inline-flex",
      "height": "4rem",
      "width": "3.2rem",
      "flexShrink": "0",
      "alignItems": "center",
      "justifyContent": "center"
    }, {
      "borderRadius": "4px",
      "backgroundColor": "rgba(0, 7, 4, 0.2) !important",
      "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
      "transitionDuration": "250ms",
      "transitionTimingFunction": "ease-in-out",
      "@media (min-width: 1024px)": {
        "backgroundColor": "var(--bg-transparent-20) !important"
      }
    }, {
      "@media (hover: hover)": {
        "&:hover": {
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(189 191 181 / var(--tw-bg-opacity))"
        }
      }
    }]}>
        <_StyledIcon icon={CaretLeft} $_css3={[isPrevDisabled && {
        "opacity": "0.3"
      }]} />
      </_StyledButton>

      <_StyledDiv2 ref={scrollRef} className="hide-scrollbar" $_css4={[{
      "display": "flex",
      "alignItems": "center",
      "columnGap": "0.4rem",
      "overflowX": "auto",
      "overflowY": "hidden"
    }]}>
        {items.map((item, idx) => {
        const asset = item.thumbnail;
        const isActive = idx === activeIndex;
        return <_StyledButton2 key={idx} data-control-idx={idx} onClick={() => onSelect(idx)} aria-label={`View ${idx + 1}`} $_css5={[{
          "position": "relative",
          "height": "4rem",
          "width": "6.2rem",
          "flexShrink": "0",
          "overflow": "hidden"
        }, {
          "borderRadius": "4px",
          "transitionDuration": "250ms",
          "transitionTimingFunction": "ease-in-out"
        }]}>
              {asset && <Asset asset={asset} imageProps={{
            width: 100,
            fit: "cover"
          }} />}
              {isActive && <_StyledDiv3 $_css6={[{
            "position": "absolute",
            "inset": "0",
            "display": "flex",
            "alignItems": "center",
            "justifyContent": "center",
            "--tw-backdrop-blur": "blur(4px)",
            "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
          }]}>
                  <_StyledSpan $_css7={[{
              "height": "0.5rem",
              "width": "0.5rem",
              "backgroundColor": "var(--blue-100-static)"
            }]} />
                </_StyledDiv3>}
            </_StyledButton2>;
      })}
      </_StyledDiv2>

      <_StyledButton3 type="button" onClick={goNext} disabled={isNextDisabled} aria-label="Next" $_css8={[{
      "display": "inline-flex",
      "height": "4rem",
      "width": "3.2rem",
      "flexShrink": "0",
      "alignItems": "center",
      "justifyContent": "center"
    }, {
      "borderRadius": "4px",
      "backgroundColor": "rgba(0, 7, 4, 0.2) !important",
      "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
      "transitionDuration": "250ms",
      "transitionTimingFunction": "ease-in-out",
      "@media (min-width: 1024px)": {
        "backgroundColor": "var(--bg-transparent-20) !important"
      }
    }, {
      "@media (hover: hover)": {
        "&:hover": {
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(73 77 75 / var(--tw-bg-opacity))"
        }
      }
    }]}>
        <_StyledIcon2 icon={CaretRight} $_css9={[isNextDisabled && {
        "opacity": "0.3"
      }]} />
      </_StyledButton3>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-e6ruhe-0"
})`${p => p.$_css}`;
var _StyledButton = _styled2("button").withConfig({
  componentId: "sc-sf-e6ruhe-1"
})`${p => p.$_css2}`;
var _StyledIcon = _styled3(Icon).withConfig({
  componentId: "sc-sf-e6ruhe-2"
})`${p => p.$_css3}`;
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-e6ruhe-3"
})`${p => p.$_css4}`;
var _StyledButton2 = _styled5("button").withConfig({
  componentId: "sc-sf-e6ruhe-4"
})`${p => p.$_css5}`;
var _StyledDiv3 = _styled6("div").withConfig({
  componentId: "sc-sf-e6ruhe-5"
})`${p => p.$_css6}`;
var _StyledSpan = _styled7("span").withConfig({
  componentId: "sc-sf-e6ruhe-6"
})`${p => p.$_css7}`;
var _StyledButton3 = _styled8("button").withConfig({
  componentId: "sc-sf-e6ruhe-7"
})`${p => p.$_css8}`;
var _StyledIcon2 = /*#__PURE__*/_styled9(Icon).withConfig({
  displayName: "controls___StyledIcon2",
  componentId: "sc-1sdvjbi-0"
})(["", ""], p => p.$_css9);